import React, {Component} from 'react';
import BigNumber from 'bignumber.js';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

class BuySell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            buyP3XReceived: 0,
            buyP3XDefault: 1,
            sellP3XReceived: 0,
            sellP3XDefault: 0,
            p3XDivs: 0
        };

        this.handleSellKeyUp = this.handleSellKeyUp.bind(this);
        this.handleSell = this.handleSell.bind(this);
        this.handleBuyKeyUp = this.handleBuyKeyUp.bind(this);
        this.handleBuy = this.handleBuy.bind(this);
    }

    async componentDidUpdate(prevProps) {

        if (this.props !== prevProps) {
            if (this.props.data.P3DTokenContract !== null) {

                let amt = (parseFloat(this.props.data.usableBalanceOf) - parseFloat(0.0001)).toFixed(4);
                if(amt>0) {
                    //sell fill
                    let sellAmt = this.props.data.web3.utils.toWei(amt, "ether");
                    let sellResult = await this.props.data.P3XTokenContract.methods.calculateEthereumReceived(sellAmt).call();
                    this.setState({
                        sellP3XDefault: amt,
                        sellP3XReceived: new BigNumber(this.props.data.web3.utils.fromWei(sellResult, "ether")).toFixed(4)
                    });
                }
                //buy fill
                let buyAmt = this.props.data.web3.utils.toWei('1', "ether");
                let buyResult = await this.props.data.P3XTokenContract.methods.calculateTokensReceived(buyAmt).call();
                this.setState({
                    buyP3XReceived: new BigNumber(this.props.data.web3.utils.fromWei(buyResult, "ether")).toFixed(4)
                });

                //p3x reinvest amt
                let p3xAmt = this.props.data.web3.utils.toWei(this.props.data.totalDividendsOf, "ether");
                let p3xResult = await this.props.data.P3XTokenContract.methods.calculateTokensReceived(p3xAmt).call();
                this.setState({
                    p3XDivs: new BigNumber(this.props.data.web3.utils.fromWei(p3xResult, "ether")).toFixed(2)
                });

            }
        }
    }

    async handleSellKeyUp(event) {
        try {
            let eventValue = event.target.value;
            this.setState({
                sellP3XDefault: eventValue
            });

            if (parseFloat(event.target.value) > 0) {
                let amt = this.props.data.web3.utils.toWei(eventValue, "ether");
                let result = await this.props.data.P3DTokenContract.methods.calculateEthereumReceived(amt).call();
                this.setState({
                    sellP3XReceived: new BigNumber(this.props.data.web3.utils.fromWei(result)).toFixed(4)
                });
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    async handleSell(event) {
        console.log('event');
        let amt = this.state.sellP3XDefault;
        console.log(amt);
        if (!parseFloat(amt)) {
            console.log(this.props.data.txtResponse.sell.amtNotValidErr);
            toast.error(this.props.data.txtResponse.sell.amtNotValidErr);
            return;
        }
        if (parseFloat(amt) <= 0) {
            console.log(this.props.data.txtResponse.sell.amtNotZeroErr);
            toast.error(this.props.data.txtResponse.sell.amtNotZeroErr);
            return;
        }
        if (parseFloat(amt) > parseFloat(this.props.data.usableBalanceOf)) {
            console.log(this.props.data.txtResponse.sell.balanceOfErr);
            toast.error(this.props.data.txtResponse.sell.balanceOfErr);
            return;
        }
        let serialized = this.props.data.web3.utils.toWei(amt);
        try {
            await this.props.data.P3XTokenContract.methods.sell(serialized, false).send({from: this.props.data.address}, (error, transactionHash) => {
                if (!error) {
                    toast.success(this.props.data.txtResponse.sell.transSuccess);
                }
                else {
                    toast.error(this.props.data.txtResponse.genericSendingTransErr);
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    async handleBuyKeyUp(event) {
        try {
            let eventValue = event.target.value;
            this.setState({
                buyP3XDefault: eventValue
            });

            if (parseFloat(event.target.value) > 0) {
                let amt = this.props.data.web3.utils.toWei(eventValue, "ether");
                let result = await this.props.data.P3DTokenContract.methods.calculateTokensReceived(amt).call();
                this.setState({
                    buyP3XReceived: new BigNumber(this.props.data.web3.utils.fromWei(result)).toFixed(4)
                });
            }
        }
        catch (error) {
            console.log(error);
        }
    }


    async handleBuy(event) {
        try {
            let amt = this.state.buyP3XDefault.toString();
            if (!parseFloat(amt)) {
                toast.error(this.props.data.txtResponse.buy.amtNotValidErr);
                console.log(this.props.data.txtResponse.buy.amtNotValidErr);
                return;
            }
            if (parseFloat(amt) <= 0) {
                toast.error(this.props.data.txtResponse.buy.amtNotZeroErr);
                console.log(this.props.data.txtResponse.buy.amtNotZeroErr);
                return;
            }
            console.log(this.props.data.MN);
            //console.log(this.props.data.P3XTokenContract.methods);
            await this.props.data.P3XTokenContract.methods.buy(this.props.data.MN).send({
                value: this.props.data.web3.utils.toWei(amt, "ether"),
                from: this.props.data.address
            }, (error, transactionHash) => {
                if (!error) {
                    toast.success(this.props.data.txtResponse.buy.transSuccess);
                }
                else {
                    toast.error(this.props.data.txtResponse.genericSendingTransErr);
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    render() {
        return (
            <div className="row mt-4">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">


                                <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <h5 className="card-title text-center">Buy P3X</h5>
                                    <div className="input-group mb-3" style={{cursor: 'not-allowed'}}>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">&nbsp;&nbsp;&nbsp;Price:&nbsp;&nbsp;&nbsp;</span>
                                        </div>
                                        <input id="buy-eth-price" type="number" readOnly
                                               className="form-control" style={{pointerEvents: 'none'}}
                                               step="any" value={this.props.data.buyPrice}/>
                                        <div className="input-group-append">
                                            <span className="input-group-text">ETH</span>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3" style={{cursor: 'not-allowed'}}>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text special-text">Amount:&nbsp;</span>
                                        </div>
                                        <input id="buy-eth-amount" type="number" readOnly className="form-control" style={{pointerEvents: 'none'}} value={this.state.buyP3XReceived} step="any"/>
                                        <div className="input-group-append">
                                            <span className="input-group-text">P3X</span>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">&nbsp;&nbsp;&nbsp;Total:&nbsp;&nbsp;&nbsp;</span>
                                        </div>
                                        <input id="buy-eth-total" type="number" className="form-control" defaultValue="1" step="any" onChange={this.handleBuyKeyUp}/>
                                        <div className="input-group-append">
                                            <span className="input-group-text">ETH</span>
                                        </div>
                                    </div>
                                    <button id="btn-buy" type="button" className="btn btn-primary btn-block" onClick={this.handleBuy}>Buy</button>
                                </div>


                                <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-2">
                                    <h5 className="card-title text-center" style={{marginBottom: '0px'}}>Global Holdings</h5>
                                    <table className="text-center" style={{width: '100%', color: 'inherit'}}>
                                        <tbody>
                                        <tr style={{borderBottom: '1px solid #1c1a1a'}}>
                                            <td style={{width: '50%', fontSize: '17px', textAlign: 'center'}}>Contract Balance</td>
                                            <td style={{width: '50%', fontSize: '17px', textAlign: 'center'}}>Total Supply</td>
                                        </tr>
                                        <tr>
                                            <td style={{fontSize: '15px', color: 'var(--primary)'}}>
                                                <div id="txt-p3d-eth-balance">{this.props.data.totalEthereumBalance_Display} ETH</div>
                                                <div id="txt-p3d-eth-balance-fiat">{this.props.data.fiatTotal} {this.props.data.currency}</div>
                                            </td>
                                            <td id="txt-p3d-total-supply" style={{verticalAlign: 'top', fontSize: '15px', color: 'var(--primary)'}}>{this.props.data.totalSupply_Display} P3D</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <h5 className="card-title text-center mt-2" style={{marginBottom: '0px'}}>Your Holdings</h5>
                                    <table className="text-center" style={{width: '100%', color: 'inherit'}}>
                                        <tbody>
                                        <tr style={{borderBottom: '1px solid #1c1a1a'}}>
                                            <td style={{width: '50%', fontSize: '17px', textAlign: 'center'}}>Total Balance</td>
                                            <td style={{width: '50%', fontSize: '17px', textAlign: 'center'}}>Dividend Earnings</td>
                                        </tr>
                                        <tr>
                                            <td style={{height: '15px', fontSize: '15px', textAlign: 'center', verticalAlign: 'top', color: 'var(--primary)'}}>
                                                <div id="txt-total-balance">{this.props.data.balanceOf_Display} P3X</div>
                                                <div id="txt-total-balance-eth">{this.props.data.totalBalanceEthAmt_Display} ETH</div>
                                                <div id="txt-total-balance-fiat">{this.props.data.fiatBalance} {this.props.data.currency} </div>
                                            </td>
                                            <td style={{height: '15px', fontSize: '15px', textAlign: 'center', verticalAlign: 'top', color: 'var(--primary)'}}>
                                                <div id="txt-total-dividends">{this.props.data.totalDividendsOf_Display} ETH</div>
                                                <div id="txt-total-dividends-fiat">{this.props.data.fiatDivs} {this.props.data.currency}</div>
                                                <div id="txt-total-dividends-p3x" style={{lineHeight: '15px', marginTop: '5px'}}>{this.state.p3XDivs} P3X
                                                    <span style={{color: 'lightgrey', fontSize: '10px', display: 'block', color: 'rgb(136, 136, 136)'}}>(if reinvested)</span>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>


                                <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-2">

                                    <h5 className="card-title text-center">Sell P3X</h5>
                                    <div className="input-group mb-3" style={{cursor: 'not-allowed'}}>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">&nbsp;&nbsp;&nbsp;Price:&nbsp;&nbsp;&nbsp;</span>
                                        </div>
                                        <input id="sell-eth-price" type="number" readOnly className="form-control" style={{pointerEvents: 'none'}} step="any" value={this.props.data.sellPrice}/>
                                        <div className="input-group-append">
                                            <span className="input-group-text">ETH</span>
                                        </div>
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">Amount:&nbsp;</span>
                                        </div>
                                        <input id="sell-amount-p3x" type="number" className="form-control" value={this.state.sellP3XDefault} step="any" onChange={this.handleSellKeyUp}/>
                                        <div className="input-group-append">
                                            <span className="input-group-text">P3X</span>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="input-group mb-3" style={{cursor: 'not-allowed'}}>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">&nbsp;&nbsp;&nbsp;Total:&nbsp;&nbsp;&nbsp;</span>
                                        </div>
                                        <input id="sell-eth-total" type="number" readOnly className="form-control" style={{pointerEvents: 'none'}} step="any" value={this.state.sellP3XReceived}/>
                                        <div className="input-group-append">
                                            <span className="input-group-text">ETH</span>
                                        </div>
                                    </div>
                                    <button id="btn-sell" type="button" className="btn btn-primary btn-block" onClick={this.handleSell}>Sell</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer/>
            </div>
        );
    }
}

export default BuySell;